"use client"

import { useForm } from "react-hook-form"
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "./ui/form"
import { z } from "zod"
import { CompanyFormSchema } from "@/schemas/company-form.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

interface Props {
    onSubmit: (data: z.infer<typeof CompanyFormSchema>) => void,
    isLoading: boolean
}


export default function CompanyForm(props: Props) {

    const form = useForm<z.infer<typeof CompanyFormSchema>>({
        resolver: zodResolver(CompanyFormSchema),
        defaultValues: {
            name: "",
            number: "",
            website: "",
        },
    });

    return (
        <Form {...form}>
            <form className="grid gap-y-4" onSubmit={form.handleSubmit(props.onSubmit)}>
                <FormField control={form.control} name="name" render={({ field }) => (
                    <FormItem>
                        <FormLabel>Name</FormLabel>
                        <FormControl>
                            <Input placeholder="Name" {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>

                )} />
                <FormField control={form.control} name="number" render={({ field }) => (
                    <FormItem>
                        <FormLabel>CVR Number</FormLabel>
                        <FormControl>
                            <Input placeholder="CVR Number" {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )} />
                <FormField control={form.control} name="website" render={({ field }) => (
                    <FormItem>
                        <FormLabel>Website</FormLabel>
                        <FormControl>
                            <Input placeholder="Website" {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>

                )} />

                <Button disabled={props.isLoading} className='cursor-pointer' type="submit">Submit</Button>
            </form>
        </Form>
    )
}